import {useMeQuery} from './useMeQuery';

export const useIsAuth = () => {
    const {query} = useMeQuery();

    return !!query.data;
};
